import {Component} from 'react';
import h from 'react-hyperscript';
import Login from 'Pages/Login/Login';
import OptIn from 'Pages/OptIn/OptIn';
import {Route, Redirect} from 'react-router';
import {OptedInContext} from '../../App';
import ScopesError from 'Components/ErrorMessage/ScopesError';
import PermissionsError from 'Components/ErrorMessage/PermissionsError';

const AdminRouteWrapper = (props) => {
  return (
    h(OptedInContext.Consumer, {}, ({optedIn, setOptedIn}) => {
      return h(AdminRoute, {
        optedIn, setOptedIn, ...props,
      });
    })
  );
};

class AdminRoute extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    if (this.props.isAdmin) {
      const {dynamicGraphSize, screenWidth} = this.props;

      if (this.props.optedIn) {
        return (
          h(Route, {
            exact: true,
            path: this.props.path,
            render: ({match}) => {
              return (
                h(this.props.component, {
                  key: this.props.key,
                  csrf: this.props.csrf,
                  needsDistrictConfig: this.state.needsDistrictConfig,
                  googleUser: this.props.googleUser,
                  idToken: this.props.googleUser.getAuthResponse().id_token,
                  userStatus: this.props.userStatus,
                  setReportName: this.props.setReportName,
                  setLatestReportName: this.props.setLatestReportName,
                  productWindowsLoading: this.props.productWindowsLoading,
                  setProductWindowsLoading: this.props.setProductWindowsLoading,
                  match,
                  dynamicGraphSize,
                  screenWidth,
                }, null)
              );
            },
          }, null)
        );
      } else {
        return (
          h(OptIn, {
            handleOptedIn: this.props.setOptedIn,
            googleUser: this.props.googleUser,
            csrf: this.props.csrf,
          }, null)
        );
      }
    } else if (this.props.userStatus && !this.props.scopesGranted) {
      return (
        h(ScopesError, {
          promptScopes: this.props.promptScopes,
        }, null)
      );
    } else if (this.props.userStatus &&
      this.props.userStatus.admin_level === 'Guest') {
      return (
        h(Redirect, {to: '/guest'})
      );
    } else if (this.props.userStatus &&
      this.props.userStatus.admin_level === 'NonAdmin') {
      return (
        h(PermissionsError, null, null)
      );
    } else {
      return (
        h(Login, {
          key: this.props.key,
          path: this.props.path,
          loginClick: this.props.loginClick,
        }, null)
      );
    }
  }
}

export default AdminRouteWrapper;
